"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorPaletteDataLoaderFactory = void 0;
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var ColorPaletteDataLoader = /** @class */ (function () {
    function ColorPaletteDataLoader(workspace) {
        this.workspace = workspace;
    }
    ColorPaletteDataLoader.prototype.getColorPalette = function (backend) {
        var _this = this;
        if (!this.cachedColorPalette) {
            this.cachedColorPalette = backend
                .workspace(this.workspace)
                .styling()
                .getColorPalette()
                .catch(function (error) {
                _this.cachedColorPalette = undefined;
                throw error;
            });
        }
        return this.cachedColorPalette;
    };
    return ColorPaletteDataLoader;
}());
/**
 * @internal
 */
exports.colorPaletteDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new ColorPaletteDataLoader(workspace); });
//# sourceMappingURL=ColorPaletteDataLoader.js.map